// F37.4 Phase 3b — sample outfit loader.
//
// Hardcoded sample outfit ID for v1. Phase 4 will replace this with a
// properly curated sample (run analyse-outfit pipeline, flip
// is_sample=true on the result row, paste the id here).
//
// To pick a TEMPORARY sample for verification:
//   UPDATE outfits SET is_sample = true
//   WHERE id = '<any complete outfit_id>' RETURNING id;
// Then paste that id below.

import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

export const SAMPLE_OUTFIT_ID = "c6d47b5e-74f7-44eb-a439-1c69727a48d9";

type OutfitRow = Database["public"]["Tables"]["outfits"]["Row"];
type DetectedItemRow = Database["public"]["Tables"]["detected_items"]["Row"];

export type SampleLoadResult =
  | { ok: true; outfit: OutfitRow; items: DetectedItemRow[] }
  | { ok: false; error: string };

export async function loadSampleOutfit(
  supabase: SupabaseClient<Database>,
): Promise<SampleLoadResult> {
  try {
    const [outfitResult, itemsResult] = await Promise.all([
      supabase.rpc("get_sample_outfit", { p_id: SAMPLE_OUTFIT_ID }),
      supabase.rpc("get_sample_outfit_items", {
        p_outfit_id: SAMPLE_OUTFIT_ID,
      }),
    ]);

    if (outfitResult.error) {
      return { ok: false, error: outfitResult.error.message };
    }

    const outfitData = outfitResult.data as unknown;
    const outfit = Array.isArray(outfitData)
      ? (outfitData[0] as OutfitRow | undefined)
      : (outfitData as OutfitRow | null);

    if (!outfit) {
      return { ok: false, error: "sample_not_found" };
    }

    const items = (itemsResult.data ?? []) as DetectedItemRow[];

    return { ok: true, outfit, items };
  } catch (err) {
    const message = err instanceof Error ? err.message : "unknown";
    return { ok: false, error: message };
  }
}
